import routes from '@/modules/archive/archive-routes';
import store from '@/modules/archive/archive-store';

export default {
    routes,
    store,
    mixins: []
}
